<template>
  <div v-if="hasLoad">
    {{reportInfo.name}}
    <el-form ref="pageForm" style="background-color: white;" label-width="160px" label-suffix=":">
      <template v-for="(blockOne,blockIndex) in blockArr" >
        {{blockOne.blockCnName}}:
        <el-row type="flex" style="flex-wrap:wrap;" :key="'block_'+blockIndex" >
          <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6" v-for="(fieldOne,fieldIndex) in blockOne.fieldArr" :key="'block_'+fieldIndex" >
            <el-form-item :label="fieldOne.cnName">
              <template v-if="fieldOne.type == 1">
                <el-select 
                  v-model="reportInfo.styleSet[fieldOne.enName]" clearable
                  :multiple="false"
                >
                  <el-option v-for="(dicOne,dicIndex) in fieldOne.dicList" :key="'dic_'+dicIndex" :label="dicOne.label" :value="dicOne.value"></el-option>
                </el-select>
              </template>
              <template v-else-if="fieldOne.type == 2">
                <template v-if="fieldOne.inputArr">
                  <el-input v-for="(inputOne,inputIndex) in fieldOne.inputArr" :key="'input_'+inputIndex" type="text" v-model="reportInfo.styleSet[inputOne.enName]" :placeholder="inputOne.placeholder"><template slot="prepend">{{inputOne.cnName}}</template></el-input>
                </template>
                <el-input v-else type="text" v-model="reportInfo.styleSet[fieldOne.enName]" :placeholder="fieldOne.placeholder"><template slot="prepend">{{fieldOne.cnName}}</template></el-input>
              </template>
            </el-form-item>
          </el-col>
        </el-row>
      </template>
      <el-row type="flex" style="flex-wrap:wrap;" >
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" >
          <el-button type="primary"  title="styleSet" @click="openDialog()">图表样式设置</el-button> 
        </el-col>
      </el-row>
      <el-row>
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24"  >
          <div style="text-align: center;margin-top: 20px">
            <el-button type="success" @click="saveInfo" :loading="fullscreenLoading"
            >
              保存
            </el-button>
            <el-button type="info" @click="cancelPage" >取消</el-button>
          </div>
        </el-col>
      </el-row>
    </el-form>
    <el-dialog v-if="addDialogFlag"
      title="设置"
      :visible.sync="addDialogFlag"
      width=98%
      top="1vh"
      center
      append-to-body>
          <!-- 按钮整体样式设置-->
          <ChartShowSet v-model="reportInfo.styleSet" :ImageList="ImageList" ></ChartShowSet>
      </el-dialog>
  </div>
</template>

<script>
import ChartShowSet from '@/components/page/pageSet/ChartShowSet.vue';
import pageUtils from '@/js/page/pageUtil.js';
import utils from '@/js/utils/util.js';

export default {
  name: 'PageShowSet',
  props: {
    initReportId: Number
  },
  data() {
    return {
      //页面ID
      reportId:0,
      //页面对象
      reportInfo:{},
      //当前设置的字段的index
      nowFieldIndex:0,
      //弹出层的打开状态
      addDialogFlag:false,
      addDialogType:0,
      // 图片库的图片
      ImageList:[],
      // 是否加载完成
      hasLoad:false,
      fullscreenLoading:false,
      // 1为 小程序(包含H5)   2为PC端设置
      sourceType:1,
      blockArr:[{
          blockCnName:"报表显示设置",
          fieldArr:[{
            cnName:"搜索条件是否显示",
            enName:"ifShowSearch",
            type:1,
            dicList:[{label:"是",value:"1"},{label:"否",value:"2"}]
          },{
            cnName:"图表分组切换是否显示",
            enName:"ifGroupChange",
            type:1,
            dicList:[{label:"是",value:"1"},{label:"否",value:"2"}]
          },{
            cnName:"数据分组切换是否显示",
            enName:"ifDataGroupChange",
            type:1,
            dicList:[{label:"是",value:"1"},{label:"否",value:"2"}]
          },{
            cnName:"是否导出",
            enName:"ifExport",
            type:1,
            dicList:[{label:"是",value:"1"},{label:"否",value:"2"}]
          },{
            cnName:"是否进行数据和图表切换",
            enName:"ifChart",
            type:1,
            dicList:[{label:"数据报表",value:"1"},{label:"图表",value:"2"},{label:"数据+图表",value:"3"}]
          }]
        }
      ]
    };
  },
  created() {
    this.hasLoad = false;
    if(this.initReportId > 0) {
      this.reportId = this.initReportId;
    }
    var paramsQuery = this.$route.query;
    if(paramsQuery.reportId > 0) {
      this.reportId = paramsQuery.reportId;
    }
    if(paramsQuery.sourceType > 0) {
      this.sourceType = paramsQuery.sourceType;
    }
//    console.log("this.sourceType===========================",this.sourceType);
    this.loadPageSet();
    this.loadImageList();
  },
  mounted() {
  },
  watch:{
  },
  computed:{
  },
  components: {
    ChartShowSet
  },
  methods: {
    /**
     * 根据页面ID 加载页面设置信息
     */
    loadPageSet(){
      var that = this;
      //读取页面 的page对象
      var url = "/pageShowSet_loadMongoInfoById.do?source=1";
      var toHtData = {};
      toHtData.dataId = that.reportId;
      toHtData.mongoName = "report";
      toHtData.mongoIdName = "reportId";
      toHtData.sourceType = that.sourceType;
      that.loading = true;

      utils.request(that,{
        url: url, //读取列表数据的接口
        data: toHtData,
        success: function (res) {
          that.loading = false;
//          console.log("res.data=============",res.data);
          if (res.data != null) {
            that.reportInfo = res.data;
            if(!that.reportInfo.styleSet) {
              var initStyleSet = {};
              that.$set(that.reportInfo,"styleSet",initStyleSet);
            }
          }
          // that.initStyleSetByBack();
          that.hasLoad = true;
        },
        fail: function () {
          that.loading = false;
          console.log("服务器异常!",error);
        }
      });
    },
    /**
     * 根据页面ID 加载页面设置信息
     */
    loadImageList(){
      var that = this;
      //读取页面 的page对象
      var url = "/model_getSqlResult.do?source=1";
      var toHtData = {};
      //分页信息 
      // toHtData.start = 0;
      // toHtData.limit = 1000 + "_flow";
      // //tableId 表id
      // toHtData.tableId = 36;
      // //pageId 页面id
      // toHtData.pageId = 61;
      toHtData.sql = "SELECT IMAGE_NAME NAME,FILES.F_MONGOID BG_URL,KW_IMAGE.ZD_TYPE TYPE FROM KW_IMAGE LEFT JOIN FILES ON FILES.F_ID = KW_IMAGE.IMAGE_URL";
      utils.request(that,{
        url: url, //读取列表数据的接口
        data: toHtData,
        success: function (res) {
          that.ImageList = res.data;
        },
        fail: function () {
          console.log("error=====" + error);
        }
      });
    },
    /**
     * 打开字段设置页面
     */
    openDialog(){
      // 搜索条件设置
      if(!this.reportInfo.styleSet) {
        this.$set(this.reportInfo,"styleSet",{});
      }
      this.addDialogFlag = true;
    },
    /**
     * 保存数据
     */
    saveInfo(){
      var that = this;
      var url = "/pageShowSet_saveMongoInfoById.do?source=1";
      var dataId = this.reportId;
      var toHtData = {};
      toHtData.dataId = dataId;
      toHtData.mongoName = "report";
      toHtData.mongoIdName = "reportId";
      toHtData.sourceType = that.sourceType;
      //进行vue新增设置的 另外保存设置 放置出现丢失的情况
      // this.backStyleSet();
      toHtData.jsonStr = JSON.stringify(that.reportInfo);
      this.fullscreenLoading = true;
      utils.request(that,{
        url: url, //读取列表数据的接口
        data: toHtData,
        success: function (res) {
          that.fullscreenLoading = false;
          if(res.data > 0) {
            that.$message({
              showClose: true,
              message: "保存成功!",
              type: 'success'
            });
          } else {
            that.$message({
              showClose: true,
              message: "保存失败,请重试!",
              type: 'error'
            });
          }
        },
        fail: function () {
          console.log("error=====" + error);
        }
      });
    },
    /**
     * 关闭页面
     */
    cancelPage(){

    }


  }
}
        
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .el-col{min-height: 41px;padding: 3px}
</style>
